import Button from '../../../components/CustomButtons/ButtonTS';
import EditAttributesOutlined from '@material-ui/icons/EditOutlined';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { NavLink } from 'react-router-dom';
import React from 'react';
import { ISystem } from '../../helpers/interfaces';
import { SYSTEM_VERSIONS } from '../../helpers/Systems';
import AcUnitIcon from '@material-ui/icons/AcUnit';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess'
import Tooltip from "@material-ui/core/Tooltip";
import RainstormIcon from '../Icons/RainstormIcon.jsx';
import DescriptionOutlined from '@material-ui/icons/DescriptionOutlined';
import WbSunnyIcon from '@material-ui/icons/WbSunny';
import Notifications from '@material-ui/icons/Notifications';
import Build from '@material-ui/icons/Build'; 
import OpenInNew from '@material-ui/icons/OpenInNew';
import VpnLock from '@material-ui/icons/VpnLock';
import NotificationImportant from '@material-ui/icons/NotificationImportant';
import Timeline from '@material-ui/icons/Timeline';
import SettingsBackupRestore from '@material-ui/icons/SettingsBackupRestore';

interface SystemSettingsIconProps {
	accountCategory: string;
	accountRole: string;
	system: ISystem;
	showBigWeatherCard: boolean;
	showSystemDocumentationIcon: boolean;
	showRainstormModeIcon: boolean;
	showServiceModeIcon: boolean;
	showTestNoticationIcon: boolean;
	showW2WebsiteIcon: boolean;
	showSystemGraphIcon?: boolean;
	showResetSensorErrorsIcon?: boolean;
	showResetSensorErrorsCard?: () => void;
	isWeatherDataValid: boolean;
	showWeatherDetails: boolean;
	showNotificationsIcon: boolean;
	handleWeatherToggle: () => void;
	showSystemDocumentationCard: () =>void;
	showRainstormModeCard: () => void;
	showTestNoticationCard: () => void;
	showServiceModeCard: () => void;
	showNotificationsCard: () => void;
	serviceModeSettingSuccess: boolean;
	settingNotificationsSuccess: boolean;
	// getSystemReport: (sysID, sysName) => void;
}

const SystemSettingsIcon = ({
	accountCategory,
	accountRole,
	system,
	handleWeatherToggle,
	showBigWeatherCard,
	showSystemDocumentationIcon,
	showRainstormModeIcon,
	showServiceModeIcon,
	showTestNoticationIcon,
	showW2WebsiteIcon,
	showSystemGraphIcon,
	showResetSensorErrorsIcon,
	showResetSensorErrorsCard,
	isWeatherDataValid,
	showWeatherDetails,
	showNotificationsIcon,
	showSystemDocumentationCard,
	showRainstormModeCard,
	showTestNoticationCard,
	showServiceModeCard,
	showNotificationsCard,
	serviceModeSettingSuccess,
	settingNotificationsSuccess,
	// getSystemReport
}: SystemSettingsIconProps) => {
	const isInstallerCategory = ['wisene', 'installer'].includes(accountCategory);
	const isInstallerRole = ['administrator', 'installer'].includes(accountRole);
	const isCommonUserRole = accountRole === 'common_user';
	const iconsRowStyle = {
		display: 'flex',
		justifyContent: !isInstallerCategory && showBigWeatherCard ? 'flex-end' : 'space-between',
	};
	const rightIconsStyle = {
		display: 'flex',
		justifyContent:  'flex-end',
	};
	const renderSystemVersion = (system: ISystem): JSX.Element => {
		const systemVersion: string = system?.W2SystemId?.String ? SYSTEM_VERSIONS.W2 : SYSTEM_VERSIONS.W4;
		const systemVersionLabel = systemVersion === SYSTEM_VERSIONS.W2 ? 'WSN' : 'LoRa';

		return (
			<div style={{ display: 'flex', alignItems: 'center', marginTop: '10px', color: 'rgb(108, 108, 108)' }}>
				{`ver: ${systemVersionLabel}`}
			</div>
		);
	};
	const renderSeasonIcon = (system: ISystem): JSX.Element => {
		return <Tooltip title={system.winterSeasonNow ? 'Winter' : 'Summer'}>
					<div style={{color: 'rgb(108, 108, 108)', display: 'flex', flexDirection: 'row'}}>
						<div style={{paddingTop: '10px'}}>{'season: '}</div>
						<div style={{color: '#00acc1'}}>{system.winterSeasonNow ? <AcUnitIcon/> : <WbSunnyIcon/>}</div>
					</div>
				</Tooltip>;
	};

	const renderSystemDocumentationIcon = (): JSX.Element => {
		if (!showSystemDocumentationIcon || isCommonUserRole) return null;
		return (
			<div style={{width: 'fit-content'}}>
			<Tooltip title={'System Documentation'}>
				<div>
					<Button
						simple
						justIcon
						onClick={showSystemDocumentationCard}
					>
						<DescriptionOutlined style={{color: '#00acc1'}} />
					</Button>
				</div>
			</Tooltip>
			</div>
		);
	};

	const renderRainstormModeIcon = (): JSX.Element => {
		if (system.systemVersion == SYSTEM_VERSIONS.W4 || !showRainstormModeIcon || !(isInstallerRole || isCommonUserRole)) return null;
	
		return (
			<Tooltip title={'Rainstorm Mode'}>
				<div>
					<Button
						color={'info'}
						simple
						justIcon
						onClick={showRainstormModeCard}
						data-testid='rainstormModeIcon'
					>
						<RainstormIcon/>
					</Button>
				</div>
			</Tooltip>
		);
	};

	const renderTestNotificationIcon = (): JSX.Element => {
		if (!showTestNoticationIcon || !isInstallerCategory) return null;
		return (
			<Tooltip title={'Test Notification'}>
				<div>
					<Button
						color={'info'}
						simple
						justIcon
						onClick={showTestNoticationCard}
					>
						<NotificationImportant/>
					</Button>
				</div>
			</Tooltip>
		);
	};

	const renderServiceModeIcon = (): JSX.Element => {
		if (system.systemVersion == SYSTEM_VERSIONS.W2 || !showServiceModeIcon) return null;
		return (
			<div style={{width: 'fit-content'}}>
			<Tooltip title={'Service Mode'}>
				<div>
					<Button
						simple
						justIcon
						onClick={showServiceModeCard}
						disabled={serviceModeSettingSuccess}
					>
						<Build style={{color: '#00acc1'}} />
					</Button>
				</div>
			</Tooltip>
			</div>
		);
	};

	const renderW2WebsiteIcon = (system): JSX.Element => {
		if (system.systemVersion == SYSTEM_VERSIONS.W4 || !showW2WebsiteIcon) return null;

		return (
			<>
				<Tooltip title={'Go to W2 website'}>
					<div>
						<Button
							color={'info'}
							justIcon
							simple
							disabled={!system.w2PublicUrl}
							onClick={() => window.open(system.w2PublicUrl, '_blank')}
						>
							<OpenInNew />
						</Button>
					</div>
				</Tooltip>
				{isInstallerCategory && (
					<Tooltip title={'Go to W2 VPN2 website'}>
						<div>
							<Button
								color={'info'}
								justIcon
								simple
								disabled={!system.w2Vpn2Url}
								onClick={() => window.open(system.w2Vpn2Url, '_blank')}
							>
								<VpnLock />
							</Button>
						</div>
					</Tooltip>
				)}
			</>
		);
	};

	const renderResetSensorErrorsIcon = (): JSX.Element => {
		if (!showResetSensorErrorsIcon || accountCategory !== 'wisene') return null;
		return (
			<Tooltip title={'Sensor error counters'}>
				<div>
					<Button
						color={'info'}
						simple
						justIcon
						onClick={showResetSensorErrorsCard}
					>
						<SettingsBackupRestore/>
					</Button>
				</div>
			</Tooltip>
		);
	};

	const renderNotificationsIcon = (): JSX.Element => {
		if (!showNotificationsIcon || !isInstallerRole) return null;
		return (
			<div style={{width: 'fit-content'}}>
			<Tooltip title={'System Notifications'}>
				<div>
					<Button
						color={'info'}
						simple
						justIcon
						onClick={showNotificationsCard}
						disabled={settingNotificationsSuccess}
					>
						<Notifications/>
					</Button>
				</div>
			</Tooltip>
			</div>
		);
	};

	// const renderSystemReportIcon = (): JSX.Element => {
	// 	if (!showSystemDocumentationIcon) return null;
	// 	return (
	// 		<div style={{width: 'fit-content'}}>
	// 		<Tooltip title={'System Report'}>
	// 			<div>
	// 				<Button
	// 					simple
	// 					justIcon
	// 					onClick={() => {
	// 						console.log('onClick getSystemReport', system.ID, system.name, getSystemReport);
	// 						getSystemReport(system.ID, system.name);
	// 					}}
	// 				>
	// 					<DescriptionOutlined style={{color: '#00acc1'}} />
	// 				</Button>
	// 			</div>
	// 		</Tooltip>
	// 		</div>
	// 	);
	// };

	return (
		<GridContainer>
			<GridItem xs={12} style={iconsRowStyle}>
				{isInstallerCategory ? renderSystemVersion(system) : null}
				<div style={rightIconsStyle}>
					{showBigWeatherCard ? (
						<Button
							color='info'
							simple
							justIcon
							data-testid='showWeather'
							onClick={handleWeatherToggle}
							disabled={!isWeatherDataValid}
						>
							{showWeatherDetails ? <ExpandMore style={{ margin: '0', color: isWeatherDataValid ? '#00acc1' : '#bbb' }} />
							: <ExpandLess style={{ margin: '0', color: isWeatherDataValid ? '#00acc1' : '#bbb' }} />
							}
							{/* <AcUnitIcon style={{ margin: '0', color: isWeatherDataValid ? '#00acc1' : '#bbb' }} /> */}
						</Button>
					) : null}
					{renderSystemDocumentationIcon()}
					{renderTestNotificationIcon()}
					{renderNotificationsIcon()}
					{renderRainstormModeIcon()}
					{renderW2WebsiteIcon(system)}
					{/* {renderSystemReportIcon()} */}
					{isInstallerCategory ? renderServiceModeIcon() : null}
					{renderResetSensorErrorsIcon()}
					{showSystemGraphIcon ? (
						<NavLink to={`/systems/${system.ID}/graph`}>
							<Tooltip title='Go to graphs'>
								<div>
									<Button color='info' simple justIcon data-testid='systemGraphIcon'>
										<Timeline />
									</Button>
								</div>
							</Tooltip>
						</NavLink>
					) : null}
					{isInstallerCategory ? (
						<NavLink to={`/systems/${system.ID}/system_settings`}>
							<Button color='info' simple justIcon data-testid='systemSettingsIcon'>
								<EditAttributesOutlined style={{ margin: '0' }} />
							</Button>
						</NavLink>
					) : null}
				</div>
			</GridItem>
			<GridItem>
				{renderSeasonIcon(system)}
			</GridItem>
		</GridContainer>
	);
};

export default SystemSettingsIcon;
